import { animate, style, transition, trigger } from '@angular/animations';

export const tooltipAnimation = [
  trigger('tooltipAnimation', [
    transition(':enter', [style({ opacity: 0, transform: 'translate(-50%, -50%)' }), animate('200ms ease-out', style('*'))]),
    transition(':leave', [style('*'), animate('200ms ease-in', style({ opacity: 0, transform: 'translate(-50%, -50%)' }))]),
  ]),
];
